export enum ImagePrintMode {
    FULL = "FULL",
    CROP = "CROP"
}
